import { useEffect, useState } from 'react';
import { getUserAttribute } from '../api/userAttribute';
export default function useUserAttribute(name, defaultValue = '') {
  const [value, setValue] = useState(defaultValue);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchAttribute = async () => {
      try {
        setLoading(true);
        const attributeValue = await getUserAttribute(name, defaultValue);
        setValue(attributeValue);
      } catch (error) {
        setValue(defaultValue);
      } finally {
        setLoading(false);
      }
    };
    void fetchAttribute();
  }, [name, defaultValue]);
  return {
    value,
    loading
  };
}